"use client";

import { SessionProvider } from "next-auth/react";
import React from "react";
import AuthStoreProvider from "./AuthStoreProvider";

export default function NextAuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SessionProvider refetchOnWindowFocus={false}>
      {/* Syncs NextAuth session → Zustand auth store on every session change */}
      <AuthStoreProvider>{children}</AuthStoreProvider>
    </SessionProvider>
  );
}
